var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-home"},[_c('review-component',{attrs:{"memberKey":_vm.memberKey}})],1),_c('page-footer',{attrs:{"performKey":_vm.memberKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }